import React from "react";
import PushNotificationsPage from "./PushNotification";

const Notifications = () => {
  return (
    <>
      <PushNotificationsPage />
    </>
  );
};

export default Notifications;
